/**
 * Cliente-side password policy alineada con backend
 * (schemas/auth.py::_validate_password_complexity).
 *
 * Reglas:
 *   • mín 8 chars
 *   • 1 mayúscula
 *   • 1 minúscula
 *   • 1 dígito
 *   • 1 símbolo
 */

export const PASSWORD_RULES = [
  { key: "length", label: "Mínimo 8 caracteres", test: (v) => v.length >= 8 },
  { key: "upper", label: "Una letra MAYÚSCULA", test: (v) => /[A-Z]/.test(v) },
  { key: "lower", label: "Una letra minúscula", test: (v) => /[a-z]/.test(v) },
  { key: "digit", label: "Un dígito (0-9)", test: (v) => /\d/.test(v) },
  {
    key: "symbol",
    label: "Un símbolo (!@#$%^&*…)",
    test: (v) => /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]/.test(v),
  },
];

export function evaluatePassword(value) {
  const v = value || "";
  const checks = PASSWORD_RULES.map((r) => ({ ...r, ok: r.test(v) }));
  const passed = checks.filter((c) => c.ok).length;
  const isValid = passed === PASSWORD_RULES.length;
  let strength = "weak";
  let strengthColor = "bg-red-400";
  let strengthLabel = "Débil";
  if (passed >= 5) {
    strength = "strong";
    strengthColor = "bg-emerald-500";
    strengthLabel = "Fuerte";
  } else if (passed >= 3) {
    strength = "medium";
    strengthColor = "bg-amber-400";
    strengthLabel = "Media";
  }
  return { checks, passed, total: PASSWORD_RULES.length, isValid, strength, strengthColor, strengthLabel };
}
